import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Card, message } from 'antd'

import { req_single_gam_graduateFresh, req_add_ars_reservationCase } from '../../api'

class ModifyQualifyModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////

    static propTypes = {
        qualify: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        awardee: {
            ResidentAddress: ''
        },
        item: {
            ReservationIProjectNid: this.props.qualify.ReservationIProjectNid,
            EligibleCode: this.props.qualify.EligibleCode,
            EligibleName: this.props.qualify.EligibleName,
            QualifyDscription: this.props.qualify.QualifyDscription,
            Division: this.props.qualify.Division,
        },
        processStatus:'NONE'
    }

    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.api_single_graduateFresh()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_single_graduateFresh = async () => {
        const { token } = this.props.user
        const { EligibleCode } = this.props.qualify

        this.setState({ loading: true })
        const result = await req_single_gam_graduateFresh(EligibleCode, token)
        this.setState({ loading: false })
        const awardee = result
        if (result) {
            const { item } = this.state
            this.setState({ awardee })
            item.ClaimerPhone = result.MobilePrincipal
            item.ReservationLocation = result.ResidentCodeAddress
            this.setState({ item })
        }
        // console.log(awardee)
    }

    api_add_applycase = async (applycase) => {
        const token = this.props.user.token
        //this.setState({ loading: true })
        const result = await req_add_ars_reservationCase(applycase, token)
        //this.setState({ loading: false })
        if (result.status === 'success') {
            message.success('預約成功，獎項將採掛號郵件送達，謝謝')
        } else {
            message.error(result.message)
        }
    }

    /////////////////////////////////////////////////////////// 

    handleChange(event) {
        const { item } = this.state
        //console.log(event)
        Object.keys(item).forEach(propertyName => {
            if (event.target.id === propertyName && event.target.value !== null) {
                item[propertyName] = event.target.value.trim()
            }
        });
        this.setState({ item })
    }

    handleSubmit(event) {
        event.preventDefault()
        const row = this.state.item
        const errors = []

        if (!row.ReservationLocation.trim()) {
            errors.push('收件地址未填')
        }
        if (!row.ClaimerPhone.trim()) {
            errors.push('連絡電話未填')
        }

        if (errors.length === 0) {
            this.api_add_applycase(row)
        } else {
            let info = errors.join(',')
            message.error(info);
        }
    }

    /////////////////////////////
    render() {
        const { EligibleCode, EligibleName } = this.state.item

        return (
            <Card>
                <form onSubmit={this.handleSubmit}>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>受獎人學號</label>
                                <input type="text" className="form-control text-primary" name="EligibleCode" id="EligibleCode" placeholder="請輸入學號" defaultValue={EligibleCode} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label><span className="text-danger">*</span>受獎人姓名</label>
                                <input type="text" className="form-control text-primary" name="EligibleName" id="EligibleName" placeholder="請輸入姓名" defaultValue={EligibleName} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <input type="submit" value="檢核受獎人資料" className="btn btn-primary btn-sm" />
                    </div>
                </form>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(ModifyQualifyModal)